<div>
    <div v-if="$route.name === 'issueContract'" class="row justify-content-center align-items-center">
        <div class="col-xl-11 col-lg-11 col-md-12">
            <div class="row">
                <div class="col-12">
                    <div class="row justify-content-center">
                        <ul class="nav">
                            <li class="nav-item category" v-for="category in contractCategories" :key="category.id">
                                <a class="nav-link" :ref="'cat-tab-'+category.id" :class="category.isActive?'active':''"
                                    @click="getTemplatesByCategory(category.id)"
                                    aria-current="page">({{category.templatesCount}}) {{category.name}} </a>
                            </li>
                        </ul>
                    </div>
                    <div class="row align-self-stretch">
                        <div v-if="templates.length==0" class="col-12">
                            <div class="alert alert-warning alert-dismissible fade show" role="alert">
                                لا يوجد بيانات!
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div v-else class="col-3 text-center d-flex align-self-stretch" v-for="item in templates"
                            :key="item.id">
                            <div class="card align-self-stretch w-100">
                                <div class="card-body">
                                    <img src="/applications/contracts/img/templates-icon.svg"
                                        alt="Contracts templates" />
                                    <h6 class="card-title normal-line-height"><b> {{item.name}} </b> </h6>
                                    <div class="">
                                        <a @click="selectTemplate(item)" class="card-link"> اختر العقد</a>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <ConfirmComponent ref="confirm" :currentUserName="currentUser.givenName"
                    :daysToCancelContract="daysToCancelContract"></ConfirmComponent>
            </div>
        </div>
    </div>
    <router-view></router-view>
</div>